import Vue from 'vue';

Vue.filter('month', (val, lng) => {
  const tr = (lng == 'tr') ? true : false;
  switch (val) {
    case 12:
      return tr ? "Aralık" : "December";
      break;
    case 11:
      return tr ? "Kasım" : "November";
      break;
    case 10:
      return tr ? "Ekim" : "October";
      break;
    case 9:
      return tr ? "Eylül" : "September";
      break;
    case 8:
      return tr ? "Ağustos" : "August";
      break;
    case 7:
      return tr ? "Temmuz" : "July";
      break;
    case 6:
      return tr ? "Haziran" : "June";
      break;
    case 5:
      return tr ? "Mayıs" : "May";
      break;
    case 4:
      return tr ? "Nisan" : "April";
      break;
    case 3:
      return tr ? "Mart" : "March";
      break;
    case 2:
      return tr ? "Şubat" : "February";
      break;
    case 1:
      return tr ? "Ocak" : "January";
      break;
    default:
      return undefined;
      break;
  }
})

